import { RouteComponentProps } from 'react-router-dom';
import { REVIEW_CYCLE_STEPS_V1 } from 'reducers/reviewCreationSlice';

import { Archive, OutlineEye, Pen, UnArchive } from 'assets/assetsV1/iconComponents';

import { routes } from 'constants/routes';

import { AgGridKebabMenuOptions } from 'uiToolkitV1/AgGridWrapperV2/types';

import { REVIEW_CYCLE_STATUSES } from '../Hooks/dataHooks/reviewsListDataHooks';

export const generateReviewListOptions = ({
  data,
  history,
  isArchive,
  archiveUnArchiveReviewCycle,
}: {
  history: RouteComponentProps['history'];
  data: {
    [key: string]: any;
  };
  isArchive: boolean;
  archiveUnArchiveReviewCycle: (params: { reviewCycleId: string; isArchive: boolean }) => void;
}) => {
  const options = [] as AgGridKebabMenuOptions;

  const reviewCycleIsInProgress = data.reviewCycle.currentStage === REVIEW_CYCLE_STATUSES.IN_PROGRESS;

  if (reviewCycleIsInProgress) {
    options.push({
      label: 'View',
      onClick: () => {
        history.push(
          routes.settings.review.reviewCycle
            .replace(':formId', data.reviewCycle.id)
            .replace(':step', data.reviewCycle.lastEnabledSection ?? REVIEW_CYCLE_STEPS_V1.NAME)
        );
      },
      Icon: OutlineEye,
    });
  } else {
    options.push({
      label: 'Edit',
      onClick: () => {
        history.push(
          routes.settings.review.reviewCycle
            .replace(':formId', data.reviewCycle.id)
            .replace(':step', REVIEW_CYCLE_STEPS_V1.NAME)
        );
      },
      Icon: Pen,
    });
  }
  if (isArchive) {
    options.push({
      label: 'Unarchive',
      onClick: () => {
        archiveUnArchiveReviewCycle({
          reviewCycleId: data.reviewCycle.id,
          isArchive: !isArchive,
        });
      },
      Icon: UnArchive,
    });
  } else {
    options.push({
      label: 'Archive',
      onClick: () => {
        archiveUnArchiveReviewCycle({
          reviewCycleId: data.reviewCycle.id,
          isArchive: !isArchive,
        });
      },
      Icon: Archive,
    });
  }

  return options;
};
